<template>
    <div v-show="showModal" class="modal-backdrop-container">
        <div class="modal-msg-confirm">
            <div class="custom-modal">
                <div class="custom-modal-content" style="max-width:700px;">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">Paiement Systempay</h1>
                        <button type="button" class="btn-close" @click="close"></button>
                    </div>

                    <div class="modal-body">
                        <div v-if="is_loading">Chargement du paiement…</div>

                        <div>
                            <div class="kr-embedded"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { toast } from "bulma-toast";
    import KRGlue from "@lyracom/embedded-form-glue";

    export default {
        name: 'systempay-smartform',

        props: {
            showModal: Boolean,
            formToken: String,
            publicKey: String
        },

        emits: ['close','paid'],

        data() {
            return {
                KR: null,
                is_loading: false,
                rendered: false,
                systempayHandlerRegistered: false,
            }
        },

        beforeUnmount() {
            this.cleanup();
        },

        async mounted() {
            console.log('systempay mounted',this.showModal,this.formToken)
            try { 
                // Charger la librairie distante 
                const { KR } = await KRGlue.loadLibrary( 
                    "https://api.systempay.fr", // endpoint 
                    this.publicKey // publicKey 
                ); 
                // Stocker KR dans le composant 
                this.KR = KR;  
                await this.renderForm();
                this.setSystempayEventHandling(); 
            } catch (err) { 
                console.error("Erreur KRGlue", err); 
            }
        },

        updated(){
 
        },


        methods: {

            async renderForm() {
                console.log('systempay renderForm');
                if (this.rendered) return;
                this.rendered = true;

                this.is_loading = true;
                await this.$nextTick();

                // Ajouter une attente de 500ms (par exemple)
                await new Promise(resolve => setTimeout(resolve, 500));

                const container = this.$el.querySelector('.kr-embedded');
                console.log('renderForm', JSON.stringify(this.$el.querySelector('.modal-body')), JSON.stringify(this.$el.querySelector('.kr-embedded')))
                if (!container) {
                    console.error('Container KR introuvable');
                    this.rendered = false;
                    this.is_loading = false;
                    return;
                }

                try {
                    await this.KR.removeForms();
                    await this.KR.setFormToken(this.formToken);
                    await this.KR.renderElements('.kr-embedded');
                } catch (e) {
                    this.rendered = false;
                    console.error(e);
                } finally {
                    this.is_loading = false;
                }
            },

            cleanup() {
                if (this.rendered && this.KR) {
                    try {
                        this.KR.removeForms();
                    } catch (e) {
                        console.warn('KR cleanup failed', e);
                    }
                }

                this.rendered = false
            },

            close() {
                this.$emit('close');
                window.location.href = '/ressources';
            },

            setSystempayEventHandling() {
                this.KR.onSubmit(paymentData => {
                    console.log("Paiement soumis", paymentData);
                    if(paymentData?.clientAnswer?.orderStatus == 'PAID'){
                        toast({
                            message: "Paiement effectué avec succès. Vous recevrez un mail de confirmation.",
                            type: "is-success",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                        this.$emit('paid', paymentData);
                    }else{
                        toast({
                            message: "Paiement non finalisé",
                            type: "is-info",
                            duration: 5000,
                            pauseOnHover: true,
                        });
                    }
                    this.$inertia.get('/ressources');
                });

                this.KR.onError(errorData => {
                    console.error("Erreur de paiement", errorData);
                    toast({
                        message: "Le paiement a échoué : " + (errorData.message || "Veuillez réessayer"),
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                    });
                });            
            },
        }
    }

</script>

<style>
.modal-backdrop-container {
    position: fixed; /* ou absolute si nécessaire */
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100; /* plus grand que le parent */
}

.custom-modal {
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  /* width: 90%; */
  /* max-width: 500px; */
  z-index: 9999;
}

.custom-modal-content {
  padding: 1.5rem;
}

.kr-embedded {
  max-width: 420px;
  margin: 0 auto;
}
</style>